export default __webpack_public_path__ + "static/media/person2@2x.072f1136.jpg";